/* Swiper */
@import 'swiper/css';
@import '../../template-parts/blocks/gallery/style.css';

/* Import Component Styles */
@import "./styleguide/typography.css";
@import "./styleguide/lists.css";
@import "./styleguide/hamburger.css";
@import "./styleguide/admin.css";
@import "./styleguide/button.css";
@import "./styleguide/form.css";
@import "./styleguide/containers.css";
@import "./styleguide/sections.css";
@import "./styleguide/utilities.css";

@tailwind base;
@tailwind components;
@tailwind utilities;

.header-blur {
  -webkit-backdrop-filter: blur(6px);
  backdrop-filter: blur(6px);
  background-color: rgba(255, 255, 255, .7);
}

#main {
  @apply pt-[70px] lg:pt-[100px];
}

strong, b {
  font-weight: bold;
}

footer * {
  .text-footer {
    @apply text-[0.813rem] leading-[1.125rem] font-heading;
  }
 .footer_title p{
  @apply text-[1.20rem] leading-[1.385rem];
 }

  transition: all 0.3s ease-out;
  a:hover,
  a:focus {
    @apply text-primary;
  }
  ul {
    @apply flex p-0 m-0 gap-6;
    li {
      @apply p-0;
    }
    li:before {
      content: none;
  }
  }
}

.wpml-ls-current-language {
  font-weight: bold;
}
 